import React, { useState } from "react";
import { TurnrModalContent, TurnrModalHeader } from "~/components/modals/TurnrModal";
import TextArea from "~/components/inputs/TextArea";
import { Button } from "~/components/buttons/Buttons"; // import UploadImageQR from "./UploadImageQR";
import { fetchComplaintImagesUrls } from "~/services";
import { ROUTES } from "~/constants";
import { getSelectedProductComplaintReasonFromReasonId } from "~/cores/productCore";
import { routeToHref } from "~/utils";
import styles from "./../ComplaintStepper.module.scss";
import UploadMultipleImageQR from "rylak-common/src/components/uploadImageQR/multiple/UploadMultipleImageQR.jsx";

const MIN_TEXT_INPUT_VALUE = 5;

export default function ComplaintStepImageAndText({ appProps, complaintStepperProps }) {
    const { getLocaleText, sessionId, addAlert } = appProps;

    const {
        onModalClose,
        product,
        onBack,
        onSaveImageAndText,
        selectedComplaintReasonId,
        selectedComplaintSubReasonId,
        selectedImages,
        setSelectedImages,
        setHandledComplaintImageIds,
        onComplaintImageUpload,
        complainTextInputValue,
        setComplainTextInputValue,
        onSelectedImageRemoved,
    } = complaintStepperProps;

    const [validated, setValidated] = useState(false);

    const qrProductSessionId = product.sessionItemId;
    const selectedComplaintReason = getSelectedProductComplaintReasonFromReasonId(product, { complaintReasonId: selectedComplaintReasonId, complaintSubReasonId: selectedComplaintSubReasonId });
    const showQRCode = selectedComplaintReason?.isImageRequired;
    const textRequired = selectedComplaintReason?.isTextRequired;

    function getInputError() {
        return textRequired && complainTextInputValue?.length < MIN_TEXT_INPUT_VALUE && getLocaleText("complaint.required-text");
    }

    function getUploadError() {
        return showQRCode && selectedImages?.length === 0 && getLocaleText("complaint.required-img");
    }

    function getErrorText() {
        return getUploadError() || getInputError();
    }

    function onContinueClick() {
        setValidated(true);
        if (getErrorText()) {
            addAlert({ content: getErrorText() });
        } else {
            onSaveImageAndText();
        }
    }

    const inputError = validated && getInputError();

    const qrCodeValue = window?.location?.origin + routeToHref(ROUTES.COMPLAINT_IMAGE.pathname, { brand: appProps?.brandName }) + "?s=" + btoa(sessionId) + "&p=" + btoa(qrProductSessionId);

    return (
        <>
            <TurnrModalHeader onBack={onBack} onClose={onModalClose} title={getLocaleText("complaint-input-step-title")} />
            <TurnrModalContent>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "30px",
                    }}
                >
                    <div style={{ width: "100%" }}>
                        {showQRCode && (
                            <UploadMultipleImageQR
                                appProps={appProps}
                                qrCodeValue={qrCodeValue}
                                imageUrlServiceFn={fetchComplaintImagesUrls}
                                imageUrlServiceFetchData={{
                                    sessionId: sessionId,
                                    productId: qrProductSessionId,
                                }}
                                onRemoved={onSelectedImageRemoved}
                                onUploadSuccess={onComplaintImageUpload}
                                alertFn={({ title, text }) => addAlert({ title, content: text })}
                                selectedImages={selectedImages}
                                setSelectedImages={setSelectedImages}
                                introText={getLocaleText("upload-image-intro")}
                                scanInfoText={getLocaleText("complaint-qr-explanation")}
                                orText={getLocaleText("or")}
                                uploadButtonText={getLocaleText("complaint-upload-computer")}
                                uploadButtonTextPhone={getLocaleText("complaint-upload-phone")}
                                secondaryColorCss={styles["secondary-color-css"]}
                            />
                        )}
                    </div>
                    <TextArea
                        minLength="5"
                        required={textRequired}
                        error={textRequired && !!inputError}
                        dataTestId={"complaint-reason-input"}
                        value={complainTextInputValue}
                        floatingText={
                            <div>
                                {textRequired ? <span style={{ marginTop: "-10px" }}>* </span> : ""}
                                {getLocaleText("complaint-input-placeholder")}
                            </div>
                        }
                        onChange={(e) => {
                            setComplainTextInputValue(e.target.value);
                        }}
                    />
                    <Button appProps={appProps} dataTestId={"complaint-input-continue"} fullWidth text={getLocaleText("continue")} onClick={onContinueClick} />
                </div>
            </TurnrModalContent>
        </>
    );
}
